import React from 'react';
import { TerminalContextProvider } from '@marijoo/react-terminal';
import { ThemeProvider } from './src/context/ThemeContext';

export const onServiceWorkerUpdateReady = () => window.location.reload();

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <TerminalContextProvider>{element}</TerminalContextProvider>
  </ThemeProvider>
);
